/**
 * Product Page Animations
 * GSAP ScrollTrigger animations for product page sections
 * Animates .animationBlock-text-zone elements as they scroll into view
 */
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // Animate each .animationBlock-text-zone independently
  document.querySelectorAll(".animationBlock-text-zone").forEach((zone) => {
    const decoration = zone.querySelector(".ab-title-top-decoration");
    const title = zone.querySelector(".ab-title");
    const paragraph = zone.querySelector(".ab-paragraph-container");
    const awardIcon = zone.querySelector(".award_icon");

    if (!decoration && !title && !paragraph && !awardIcon) {
      return;
    }

    ScrollTrigger.create({
      trigger: zone,
      start: "bottom bottom",
      end: "bottom bottom",
      once: true,
      onEnter: () => {
        if (decoration) {
          gsap.to(decoration, {
            x: 0,
            opacity: 1,
            duration: 1.5,
            ease: "power2.out",
          });
        }

        if (title) {
          gsap.to(title, {
            y: 0,
            opacity: 1,
            duration: 1.5,
            delay: 0.3,
            ease: "power2.out",
          });
        }

        if (paragraph) {
          gsap.to(paragraph, {
            y: 0,
            opacity: 1,
            duration: 1.5,
            delay: 0.5,
            ease: "power2.out",
          });
        }

        if (awardIcon) {
          gsap.to(awardIcon, {
            y: 0,
            opacity: 1,
            duration: 1.5,
            delay: 0.9,
            ease: "power2.out",
          });
        }
      },
    });
  });

  // Quotes slider with arrow navigation
  if (typeof Swiper !== "undefined") {
    const quotesSliderEl = document.querySelector("._1_quotes_slider");
    if (quotesSliderEl) {
      new Swiper("._1_quotes_slider", {
        slidesPerView: "auto",
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        grabCursor: true,

        navigation: {
          nextEl: ".qts_slider_arrow_wrp_right",
          prevEl: ".qts_slider_arrow_wrp_left",
        },

        pagination: {
          el: "._1_qt_pagination",
          clickable: true,
        },

        breakpoints: {
          0: {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 8,
          },
          991: {
            slidesPerView: "auto",
            centeredSlides: false,
            spaceBetween: 8,
            slidesOffsetBefore: 100,
            slidesOffsetAfter: 60,
            pagination: false,
          },
        },
      });
    }
  }

  // Layers section - scroll animations for layer images and pointers
  document.querySelectorAll(".or_22_layrs_wrp").forEach((zone) => {
    ScrollTrigger.create({
      trigger: zone,
      start: "top 46%",
      end: "bottom bottom",
      once: true,
      onEnter: () => {
        gsap.to(zone.querySelector(".or_22_l_img_2"), {
          y: 0,
          duration: 1,
          ease: "power2.out",
        });

        gsap.to(zone.querySelector(".or_22_l_img_3"), {
          y: 0,
          duration: 1,
          ease: "power2.out",
        });

        gsap.to(zone.querySelector(".or_22_l_img_4"), {
          y: 0,
          duration: 1,
          ease: "power2.out",
        });

        gsap.to(zone.querySelector(".or_22_l_img_5"), {
          y: 0,
          duration: 1,
          ease: "power2.out",
        });

        // Pointer bounce animations
        const tl = gsap.timeline();
        tl.to(".or_22_pointer_1", {
          scale: 1.1,
          duration: 0.1,
          delay: 1,
          ease: "power2.out",
        });
        tl.to(
          ".or_22_pointer_1",
          { scale: 1, duration: 0.1, ease: "power2.out" },
          ">0.1"
        );

        const t2 = gsap.timeline();
        t2.to(".or_22_pointer_2", {
          scale: 1.1,
          duration: 0.1,
          delay: 1.1,
          ease: "power2.out",
        });
        t2.to(
          ".or_22_pointer_2",
          { scale: 1, duration: 0.1, ease: "power2.out" },
          ">0.1"
        );

        const t3 = gsap.timeline();
        t3.to(".or_22_pointer_3", {
          scale: 1.1,
          duration: 0.1,
          delay: 1.2,
          ease: "power2.out",
        });
        t3.to(
          ".or_22_pointer_3",
          { scale: 1, duration: 0.1, ease: "power2.out" },
          ">0.1"
        );

        const t4 = gsap.timeline();
        t4.to(".or_22_pointer_4", {
          scale: 1.1,
          duration: 0.1,
          delay: 1.3,
          ease: "power2.out",
        });
        t4.to(
          ".or_22_pointer_4",
          { scale: 1, duration: 0.1, ease: "power2.out" },
          ">0.1"
        );
      },
    });
  });

  // Layers section - pointer click interactions
  const pointers = document.querySelectorAll("[class^='or_22_pointer_']");
  const layers = [
    document.querySelector(".or_22_l_img_1"),
    document.querySelector(".or_22_l_img_2"),
    document.querySelector(".or_22_l_img_3"),
    document.querySelector(".or_22_l_img_4"),
    document.querySelector(".or_22_l_img_5"),
  ];
  const boxes = {
    1: document.querySelector(".or_layer_1_box"),
    2: document.querySelector(".or_layer_2_box"),
    3: document.querySelector(".or_layer_3_box"),
    4: document.querySelector(".or-layer_4_box"),
  };

  // Hide all info boxes on load
  Object.values(boxes).forEach((b) => {
    if (b) {
      b.style.display = "none";
    }
  });

  let activeLayer = null;

  pointers.forEach((pointer, i) => {
    const index = i + 1;
    const layer = document.querySelector(`.or_22_l_img_${index}`);
    const icon = pointer.querySelector(".or_inf_icon");

    pointer.addEventListener("click", () => {
      const isActive = activeLayer === index;

      // Reset all layers and boxes
      layers.forEach((l) => {
        if (l) l.style.opacity = "1";
      });
      Object.values(boxes).forEach((b) => {
        if (b) b.style.display = "none";
      });
      document
        .querySelectorAll(".or_inf_icon")
        .forEach((ic) => ic.classList.remove("rotated"));
      pointers.forEach((p) => (p.style.display = "flex"));

      if (!isActive) {
        activeLayer = index;
        // Dim other layers
        layers.forEach((l) => {
          if (l && l !== layer) l.style.opacity = "0.1";
        });
        // Show info box
        if (boxes[index]) boxes[index].style.display = "flex";
        // Hide other pointers
        pointers.forEach((p) => {
          if (p !== pointer) p.style.display = "none";
        });
        // Rotate icon
        if (icon) icon.classList.add("rotated");
      } else {
        activeLayer = null;
      }
    });
  });

  // Social slider (testimonials)
  if (typeof Swiper !== "undefined") {
    const socialSliderEl = document.querySelector("._1_social_slider");
    if (socialSliderEl) {
      new Swiper("._1_social_slider", {
        slidesPerView: "auto",
        spaceBetween: 8,
        grabCursor: true,
        centeredSlidesBounds: true,
        slidesOffsetBefore: 8,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 8,
          },
        },
      });
    }
  }

  // Animate each .animationBlock-blocks section separately
  document
    .querySelectorAll(".animationBlock-blocks")
    .forEach((blockSection) => {
      ScrollTrigger.create({
        trigger: blockSection,
        start: "bottom bottom",
        end: "bottom bottom",
        once: true,
        onEnter: () => {
          blockSection
            .querySelectorAll(".ab-animated-element-2")
            .forEach((el) => {
              gsap.to(el, {
                x: 0,
                opacity: 1,
                duration: 1.5,
                ease: "power2.out",
              });
            });
        },
      });
    });

  document.querySelectorAll(".ab-oneVideo-right").forEach((blockSection) => {
    ScrollTrigger.create({
      trigger: blockSection,
      start: "bottom bottom",
      end: "bottom bottom",
      once: true,
      onEnter: () => {
        blockSection
          .querySelectorAll(".ab-animated-element-2")
          .forEach((el) => {
            gsap.to(el, {
              x: 0,
              opacity: 1,
              duration: 1.5,
              ease: "power2.out",
            });
          });
      },
    });
  });

  document.querySelectorAll(".ab-twoVideo-right").forEach((blockSection) => {
    ScrollTrigger.create({
      trigger: blockSection,
      start: "bottom bottom",
      end: "bottom bottom",
      once: true,
      onEnter: () => {
        blockSection
          .querySelectorAll(".ab-animated-element-2")
          .forEach((el) => {
            gsap.to(el, {
              x: 0,
              opacity: 1,
              duration: 1.5,
              ease: "power2.out",
            });
          });
      },
    });
  });
});
